const Link = ({href = '', rel = '', target = '', external = false, children, ...props} = {}) => {
  if (external) {
    rel = 'noopener nofollow';
    target = '_blank';
  }

  return <a href={href} target={target} rel={rel} {...props}>{children}</a>;
};

export default Link;
